import React, { Component } from "react";
import LoadingPanel from "./LoadingPanel";
import { tovarController } from "../../controllers/tovar.controller";

/**
 * Obecná komponenta pro zobrazení obrázku tovaru podle zadaného idVariant nebo idKarta.
 *
 * @class TovarFoto
 * @extends {Component}
 */
class TovarFoto extends Component {
    state = {
        loading: true,
        picture: null
    };

    componentDidMount() {
        this.getTovarFoto(this.props.idVariant, this.props.idKarta);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.idVariant !== nextProps.idVariant || this.props.idKarta !== nextProps.idKarta) {
            this.getTovarFoto(nextProps.idVariant, nextProps.idKarta);
            return false;
        }
        return true;
    }

    getTovarFoto(idVariant, idKarta) {
        this.setState({
            loading: true
        });

        if (idVariant || idKarta) {
            tovarController.getTovarFoto(idVariant, idKarta).then((response) => {
                this.setState({
                    loading: false,
                    picture: response
                });
            });
        } else {
            this.setState({
                loading: false,
                picture: null
            });
        }
    }

    renderResult() {
        let background = {
            background: "grey"
        };
        if (this.state.picture && this.state.picture.valid) {
            background = {
                backgroundImage: "url(" + this.state.picture.dataBase64 + ")"
            };
        }
        return (
            <div style={background} className={this.props.bigFoto ? "tovar-foto-big" : "tovar-foto"}>
                <div>
                    {this.state.picture && !this.state.picture.valid && this.state.picture.styl && (
                        <div>
                            <h3>{this.state.picture.styl}</h3>
                        </div>
                    )}
                </div>
                <div>
                    {this.state.picture && !this.state.picture.valid && this.state.picture.nazevFoto && (
                        <React.Fragment>
                            <div className="text-center">
                                <h2>NEPLATNÉ FOTO</h2>
                            </div>
                            <div className="text-center">
                                <p>{this.state.picture.relativePath}</p>
                            </div>
                        </React.Fragment>
                    )}
                    {(!this.state.picture || (!this.state.picture.valid && !this.state.picture.nazevFoto)) && (
                        <div className="text-center">
                            <h2>BEZ FOTO</h2>
                        </div>
                    )}
                </div>
                <div className="tovar-foto-tagy">
                    {this.state.picture && this.state.picture.tagy.length > 0 && this.state.picture.tagy.map((tag, index) => {
                        var style = {};
                        if (tag.zvyraznit === true) {
                            style = { color: "red" };
                        }

                        return (
                            <h3 key={index} style={style}>
                                {tag.tag}
                            </h3>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderResult();

        return <div>{contents}</div>;
    }
}

export default TovarFoto;



// WEBPACK FOOTER //
// ./src/components/common/TovarFoto.js